import React from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

// NOTE: session bootstrap lives in Routes/AuthProtected.js, which wraps every
// authenticated route. It used to ALSO run here — but App mounts on public pages
// too (/login, /reset-password), so each protected page load fired /auth/me twice
// against a 100-req/15-min per-IP limiter, and burning that budget produced 429s
// that the old error handling reported to the user as "signed out".
function App() {
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
